import { FILTER_TYPE_SEPARATOR } from 'views/OfferDesign/OfferDesign.consts';
import { FilterCriteria, OfferDesignRow } from 'views/OfferDesign/OfferDesign.types';

export const getParam = (params: URLSearchParams, key: string): string => params.get(key) || '';

export const getArrayParam = (
  params: URLSearchParams,
  key: string
): string[] => {
  const value = params.get(key);
  return value ? value.split(FILTER_TYPE_SEPARATOR) : [];
};

export const toggleArrayValue = (
  current: string[],
  value: string
): string[] => current.includes(value) ? current.filter((v) => v !== value) : [...current, value];

export const filterOffers = (
  offers: OfferDesignRow[],
  { externalId, name, types }: FilterCriteria
): OfferDesignRow[] => {
  return offers.filter((offer) => {
    if (
      externalId &&
      !offer.externalId?.toLowerCase().includes(externalId.toLowerCase())
    ) {
      return false;
    }
    if (name && !offer.name?.toLowerCase().includes(name.toLowerCase())) {
      return false;
    }
    if (types.length > 0 && !types.includes(offer.offerUiType || '')) {
      return false;
    }
    return true;
  });
};

export const normalizeBgColor = (backgroundColor: unknown) => {
  if (!backgroundColor) return undefined;
  if (typeof backgroundColor === 'string') return { colorOne: backgroundColor };
  return backgroundColor;
};

export const sanitizeExternalId = (value?: string) => {
  if (!value) return '';
  return value.trim().replace(/\s+/g, '_');
};

export const formatName = (name?: string, isDup?: boolean) => {
  if (!name) return '';
  return isDup ? `${name}_copy` : name;
};

export const handleButtonSuffixUpload = (
  setFieldValue: (field: string, value: unknown) => void,
  url: string,
  name: string,
  mimeType: string
) => {
  const isAnimation =
    name?.endsWith('.json') ||
    mimeType === 'application/json' ||
    mimeType?.includes('json');

  if (isAnimation) {
    setFieldValue('buttonSuffixAnimation', url);
    setFieldValue('buttonSuffixImage', '');
  } else {
    setFieldValue('buttonSuffixImage', url);
    setFieldValue('buttonSuffixAnimation', '');
  }
};
